/**
 * @copyright Copyright (c) 2020, KNE GmbH.
 *
 * @author Jan Duwe <jan.duwe@kne.de>
 *
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License, version 3,
 * as published by the Free Software Foundation.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License, version 3,
 * along with this program.  If not, see <http://www.gnu.org/licenses/>
 *
 */

import { Vue } from 'vue-property-decorator'
import Vuex, { StoreOptions } from "vuex";
import { IRootState } from "../model/RootState";

import { user } from "@/store/User/index";
import { snackbar } from "@/store/snackbar/index";
import { products } from './Products'
import { core } from './core'

import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

Vue.use(Vuex)


const store: StoreOptions<IRootState> = {
  modules: {
      user,
      snackbar,
      products,
      core
  },
  state: {
      version: "0.1.0",
  },

  plugins:[createPersistedState({
    getState: (key) => Cookies.getJSON(key),
    setState: (key, state) => {
      Cookies.set(key, state, { expires: 3, secure: true })
    }
  })]
};

export default new Vuex.Store<IRootState>(store);